import request, { ResponsePageableData } from '@/libs/request'

/** 同步绿云酒店信息 */
export const pullPMSHotelInfo = (data?) => request<ResponsePageableData>({ url: '/adminapi/MicrowinPms/syncHotel', data })
